import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { Button, Grid, Box, Typography, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
// import { ReactComponent as HeartLogo } from '../../images/Logo-Rebekah.svg';
// import Header from '../../components/header';
import { ReactComponent as AppleStore } from '../../images/apple-store.svg';
import Link from '@mui/material/Link';
import { ReactComponent as GooglePlay } from '../../images/google-play.svg';

const PhoneMessage = () => {
  // const {navigation} = props;
  // const dispatch = useDispatch();
  // const [active, setActive] = useState(true);
  let navigate = useNavigate();

  const detectMobileType = () =>
    /iPhone|iPad|iPod/i.test(navigator.userAgent)
      ? 'iPhone'
      : /Android/i.test(navigator.userAgent)
      ? 'Android'
      : 'Desktop';
  console.log(detectMobileType()); // "Mobile" or "Desktop"

  return (
    <Grid container component="main" columnSpacing={1} sx={styles.containerStyle}>
      <CssBaseline />
      {/*<Grid item xs={12} sx={styles.headerStyle}>
        <Box component="img" src={require('./HeartOpinion-Logo.png')} />
      </Grid>*/}
      <Grid item xs={12} sx={styles.headerStyle}>
        <Box component="img" src={require('./HeartOpinion-Logo.png')}></Box>
      </Grid>
      <Grid item xs={12} sx={styles.contentStyle}>
        <Box sx={styles.formCardContainerStyle}>
          <Stack direction="row" spacing="8px" sx={styles.formCardTitleStyle}>
            <Typography variant="h5">Using Mobile?</Typography>
          </Stack>
          <Stack direction="column" spacing="20px">
            <Typography style={{ fontSize: 18, textAlign: 'center' }}>
              The HeartOpinion website is not designed to work on a mobile device.
            </Typography>
            <Typography style={{ fontSize: 18, textAlign: 'center' }}>
              We strongly recommend that you download the “HeartOpinion” app from the Apple Store.
            </Typography>
          </Stack>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Box sx={{ mt: 2, position: 'relative' }}>
              {detectMobileType() === 'iPhone' && (
                <Link
                  color="inherit"
                  href="https://apps.apple.com/us/app/heartopinion/id1529536456"
                  target="_blank"
                  rel="noopener noreferrer">
                  <AppleStore />
                </Link>
              )}
              {detectMobileType() === 'Android' && (
                <Link
                  color="inherit"
                  href="https://play.google.com/store/apps/details?id=org.childrenshospital.hcsop"
                  target="_blank"
                  rel="noopener noreferrer">
                  <GooglePlay />
                </Link>
              )}
            </Box>
            <Box sx={{ m: 0, position: 'relative' }}>
              <Button
                fullWidth
                // variant="contained"
                color="secondary"
                sx={styles.formCardButtonStyle}
                onClick={() => navigate('/sop2web/signin')}>
                Continue to website (not recommended)
              </Button>
            </Box>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} sx={styles.footerStyle}>
        <Box component="footer">
          <Box component="img" src={require('./BCH-logo.png')} />
        </Box>
      </Grid>
    </Grid>
  );
};

const styles = {
  containerStyle: {
    height: '93vh',
    border: 0,
    backgroundColor: '#003087'
  },
  contentStyle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
    // minWidth: 600,
    // border: 1
    // my: 8
  },
  formCardContainerStyle: {
    display: 'flex',
    // border: 2,
    // boxShadow: 1,
    borderColor: '#747678',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: 338,
    padding: 0,
    background: '#FFFF'
  },
  formCardButtonStyle: {
    mt: 0,
    mb: 5,
    flex: 0,
    width: 200
  },
  headerStyle: {
    backgroundColor: '#003087',
    // height: 50,
    display: 'flex',
    // border: 4,
    alignItems: 'flex-start',
    justifyContent: 'center'
  },
  footerStyle: {
    // height: 66,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    // border: 2,
    mt: 'auto'
  },
  formCardTitleStyle: {
    my: 4,
    mx: 4,
    alignItems: 'center',
    justifyContent: 'center'
  }
};
export default PhoneMessage;
